module.exports = "* {\n  width: 100%; }\n\n.container {\n  height: 100%;\n  margin: 0px;\n  max-width: none;\n  padding: 24px; }\n"